import { useCallback } from 'react'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'
import { useToast } from '@hooks'
import { useSignal } from '@preact/signals-react'


export default function useReportsHandlerCopy() {
	const { showToast } = useToast()
	const isLoading = useSignal(false)


	const handleSubmit = useCallback((userId, reportsList) => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.REPORTS}/copy-multi`, { idReport: reportsList, uid: userId })
			.then(() => {
				isLoading.value = false
				isOpenReportsTransferModal.value = []
				showToast.success('Reports successfully copied to destintation user')
			})
			.catch(() => {
				isLoading.value = false
				showToast.error('Failed copying reports to destintation user')
			})
	}, [])

	return {
		handleSubmit,
		isLoading: isLoading.value,
	}
}